<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/interface/show/list";
import editDialog from "@/components/mall/interface/show/editDialog";

export default {
  name: "interface_show",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {},
};
</script>